//@ts-nocheck
//@ts-ignore
/* eslint-disable */
import styles from './style.module.scss';
import { ReactComponent as BackIcon } from '../../../assets/images/arrowLeft.svg';
import { t } from '@web-solutions/module-localization';
import { useNav } from 'src/onboarding/hooks/nav';
import Button from 'src/onboarding/components/ui/button/Button';
import { Title } from 'src/onboarding/components/typography/Title/Title';
import { Text } from 'src/onboarding/components/typography/Text/Text';

function TransitionSeventh() {
  const { onNext, onPrev, currentIndex } = useNav();

  return (
    <div className={styles.page}>
      {currentIndex !== 0 && (
        <div className={styles.back} onClick={onPrev}>
          <BackIcon />
        </div>
      )}
      <div className={styles.content}>
        <div className={styles.wrapperInfo}>
          <Title className={styles.title}>{t('onboarding.fuelsProgress.title')}</Title>
          <Text semibold className={styles.description}>
            {t('onboarding.fuelsProgress.subTitle')}
          </Text>
        </div>
        <div className={styles.image}></div>
      </div>
      <div className={styles.continue}>
        <div className={styles.blur}></div>
        <Button onClick={onNext} title={t('onboarding.fuelsProgress.continue')} />
      </div>
    </div>
  );
}

export default TransitionSeventh;
